import { useMutation, useQuery } from '@tanstack/react-query';

import { errorHandler } from '../helpers';
import { $api } from '../service';
import { globalConst } from '..';

export const useFeedbackErrorType = (testId?: number) => {
  const { data: errorType, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_FEEDBACK_ERROR_TYPE],
    queryFn: async () => {
      const { data } = await $api.get<any>('/errortype');

      return data;
    },
    enabled: !!testId
  });

  return { errorType, ...args };
};

export const useSendFeedback = () =>
  useMutation({
    mutationFn: async (feedback: { error_id: number; massage: string; question_id?: number }) => {
      const { data } = await $api.post('/feedback', feedback);

      return data;
    },
    onError: errorHandler()
  });
